import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ExcelExportService } from "src/app/services/excel-export.service";
import { ReportService } from "src/app/services/report.service";
import { ShiftTenementsService } from "src/app/services/shift-tenements.service";

@Component({
  selector: "app-secure-shift-tenements",
  templateUrl: "./shift-tenements.component.html",
  styleUrls: ["./shift-tenements.component.scss"],
})
export class ShiftTenementsComponent implements OnInit {
  
  isLoading = false;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  lotteryList: {[key: number]: string};
  applicationSummaryReportKey: number;
  shiftingTenementStatus: string;

  constructor(
    private router: Router,
    private reportService: ReportService,
    private shiftTenementsService: ShiftTenementsService,
    private excelExportService: ExcelExportService
  ) {}

  ngOnInit(): void {
    this.loadData();
    this.form = new FormGroup({
      lotteryKey: new FormControl("", Validators.required),
    });
  }

  loadData() {
    this.isLoading = true;
    this.shiftTenementsService.initShiftTenementsForm()
    .subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.lotteryList = data.lotteryList;
          this.applicationSummaryReportKey = data.applicationSummaryReportKey;
        }
        else {
          this.shiftTenementsService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.shiftTenementsService.errorToast(error?.error?.message || error?.error?.errorMessage);
        this.isLoading = false;
      }
    );
  }

  onChangeLottery(e: any) {
    this.shiftingTenementStatus = null;
    this.isLoading = true;
    this.shiftTenementsService.fetchShiftTenementStatusForLottery(e.key)
    .subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.shiftingTenementStatus = data.shiftTenementStatus;
        }
        else {
          this.shiftTenementsService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.shiftTenementsService.errorToast(error?.error?.message || error?.error?.errorMessage);
        this.isLoading = false;
      }
    );
  }

  shiftTenements() {
    this.shiftingTenementStatus = null;
    if (this.form.valid) {
      this.isLoading = true;
      this.shiftTenementsService.shiftTenementStatusForLottery(this.form.value.lotteryKey?.key)
      .subscribe((data) => {
          this.isLoading = false;
          if(data.status === 'SUCCESS') {
            this.onChangeLottery({key: this.form.value.lotteryKey?.key});
          }
          else {
            this.shiftTenementsService.errorToast(data.errorMessage);
          }
          this.isSubmitDisabled = false;
        },
        (error) => {
          this.shiftTenementsService.errorToast(error?.error?.message || error?.error?.errorMessage);
          this.isLoading = false;
          this.isSubmitDisabled = false;
        }
      );
    }
  }

  approveShiftOfTenements() {
    this.shiftingTenementStatus = null;
    if (this.form.valid) {
      this.isLoading = true;
      this.shiftTenementsService.approveShiftTenementStatusForLottery(this.form.value.lotteryKey?.key)
      .subscribe((data) => {
          this.isLoading = false;
          if(data.status === 'SUCCESS') {
            this.onChangeLottery({key: this.form.value.lotteryKey?.key});
          }
          else {
            this.shiftTenementsService.errorToast(data.errorMessage);
          }
          this.isSubmitDisabled = false;
        },
        (error) => {
          this.shiftTenementsService.errorToast(error?.error?.message || error?.error?.errorMessage);
          this.isLoading = false;
          this.isSubmitDisabled = false;
        }
      );
    }
  }

  generateApplicationSummaryReport() {
    if (this.form.valid) {
      this.isLoading = true;     
      this.reportService.generateReport(this.applicationSummaryReportKey, {
        lotteryKey: this.form.value.lotteryKey?.key
      })
      .subscribe((data) => {
        this.isSubmitDisabled = false;
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.downloadFile(data.base64File, data.fileName);
        }
        else {
          this.reportService.errorToast(data.errorMessage);  
        }
      }, error => {
        this.isLoading = false;
        this.isSubmitDisabled = false;
        this.reportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
      });
      
    }
    else {
      this.isSubmitDisabled = false;
    }
  }

  generateShiftingTenementSummary() {
    this.shiftTenementsService.generateShiftingTenementSummary(this.form.value.lotteryKey?.key)
    .subscribe((data) => {
      this.isSubmitDisabled = false;
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.excelExportService.exportExcel(data.title, data.columnNames, 
          data.lst, data.columnWidths, 
          data.generatedBy, data.generatedOn);
      }
      else {
        this.reportService.errorToast(data.errorMessage);  
      }
    }, error => {
      this.isLoading = false;
      this.isSubmitDisabled = false;
      this.reportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });
  }

  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `${base64}`;
    const link = document.createElement("a")
    link.href = src
    link.download = fileName
    link.click()
    
    link.remove()
  }
}